var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "search-input-field" },
    [
      _c("ui-model-provider", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var value = ref.value
              var updateValue = ref.updateValue
              var updateValueRaw = ref.updateValueRaw
              return [
                _c(
                  "ui-input",
                  _vm._b(
                    {
                      attrs: {
                        type: "search",
                        facets: ["base", "search", "large"],
                        value: value
                      },
                      on: { input: updateValue }
                    },
                    "ui-input",
                    _vm.$attrs,
                    false
                  ),
                  [
                    _c("template", { slot: "actions" }, [
                      _c(
                        "button",
                        {
                          staticClass: "search-input-field--button",
                          attrs: {
                            type: "submit",
                            "aria-label": _vm.searchLabel,
                            title: _vm.searchLabel
                          }
                        },
                        [
                          _c("ui-icon", {
                            attrs: { symbol: "search", size: "medium" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      value
                        ? _c(
                            "button",
                            {
                              staticClass: "search-input-field--button",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return updateValueRaw("")
                                }
                              }
                            },
                            [
                              _c("ui-icon", {
                                attrs: {
                                  symbol: "close",
                                  size: _vm.clearIconSize
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ])
                  ],
                  2
                )
              ]
            }
          }
        ]),
        model: {
          value: _vm.currentValue,
          callback: function($$v) {
            _vm.currentValue = $$v
          },
          expression: "currentValue"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-71018cc4", { render: render, staticRenderFns: staticRenderFns })
  }
}